export default {
  ru: {
    calculator: {
      weightLabel: 'Вес посылки, кг ({lbs_value}lbs)',
      priceLabel: 'Стоимость, USD'
    }
  }
}
